import { render, staticRenderFns } from "./UpdateCustomerBeneficName.vue?vue&type=template&id=2b213a7d&scoped=true"
import script from "./UpdateCustomerBeneficName.vue?vue&type=script&lang=js"
export * from "./UpdateCustomerBeneficName.vue?vue&type=script&lang=js"
import style0 from "./UpdateCustomerBeneficName.vue?vue&type=style&index=0&id=2b213a7d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b213a7d",
  null
  
)

export default component.exports